module.exports = __webpack_public_path__ + "ID.png?b0642a85c0fa61ab2469e096266166c3";